/**
 * Audit API hooks — TanStack Query layer over /api/audit.
 *
 * Read-only access to the append-only audit log. Admin only (enforced
 * server-side). Filterable by `entityType` / `entityId` for entity-scoped views.
 */
import { useQuery } from '@tanstack/react-query';
import { api, qs } from '../../lib/api.js';
import type { AuditEntry, Paginated } from '@shared/types';

export const auditKeys = {
  all: ['audit'] as const,
  list: (params?: { entityType?: string; entityId?: string }) =>
    [...auditKeys.all, 'list', params ?? {}] as const,
};

/** List audit entries, optionally scoped by entity type/id. Admin only. */
export function useAuditLog(params?: { entityType?: string; entityId?: string }) {
  return useQuery({
    queryKey: auditKeys.list(params),
    queryFn: () =>
      api.get<Paginated<AuditEntry>>(`/api/audit${qs(params)}`),
  });
}
